var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import withAuth from "@irati/auth/helpers/auth/withAuth";
import { H3 } from "@irati/ui/src/Headings";
import productPermissionsService from "@irati/permissions/services/products";
import History from "@irati/utils/history";
import Loading from "@irati/ui/src/Loading";
import { hangPromise } from "@irati/utils/promise";
import { injectIntl } from "@irati/utils/lang";
import { Hr } from "@irati/ui/src/Layout";
import Team from "../../../components/Teams/TeamList/Team";
var UserGroups = /** @class */ (function (_super) {
    __extends(UserGroups, _super);
    function UserGroups(props) {
        var _this = _super.call(this, props) || this;
        _this.getProducts = function () {
            var business = _this.props.auth.business;
            return productPermissionsService.get(business).then(function (_a) {
                var permissionsForTenant = _a.permissionsForTenant, permissionsForAllTeams = _a.permissionsForAllTeams;
                _this.setState({ permissionsForTenant: permissionsForTenant, permissionsForAllTeams: permissionsForAllTeams });
            });
        };
        _this.handleSetCurrentTeam = function (_a) {
            var team = _a.team;
            History.push({
                pathname: "/admin/products/" + team.uuid,
                state: {
                    team: team
                }
            });
        };
        _this.state = {
            permissionsForAllTeams: [],
            permissionsForTenant: undefined,
            load: hangPromise()
        };
        return _this;
    }
    UserGroups.prototype.componentDidMount = function () {
        this.setState({
            load: this.getProducts()
        });
    };
    UserGroups.prototype.render = function () {
        var _this = this;
        var _a = this.state, permissionsForTenant = _a.permissionsForTenant, permissionsForAllTeams = _a.permissionsForAllTeams, load = _a.load;
        var formatMessage = this.props.formatMessage;
        var buttonText = "admin.components.teamProductPermissions.button.text";
        return (React.createElement(Loading, { load: load },
            React.createElement(Team, { public_name: formatMessage({ id: "admin.containers.products.companyWide" }), permissionsForTenant: permissionsForTenant, buttonText: buttonText, hideHr: true, largeHeading: true }),
            permissionsForAllTeams.length > 0 && (React.createElement(React.Fragment, null,
                React.createElement(Hr, null),
                React.createElement(H3, null, formatMessage({ id: "admin.containers.products.groupProducts" })))),
            permissionsForAllTeams.map(function (team) {
                return (React.createElement(Team, { public_name: team.team.public_name, permissionsForTenant: permissionsForTenant, permissionsForTeam: team.permissions, buttonText: buttonText, setCurrentTeam: function () { return _this.handleSetCurrentTeam(team); } }));
            })));
    };
    return UserGroups;
}(Component));
export default injectIntl(withAuth(UserGroups));
